export enum RichFeatureAction {
  GET_IT,
  PLACE_HOLD
}
